<template>
  <div class="layout-vertical-center">
    <el-card style="max-width: 552px;">
      <template #header>{{ $t('forgot.title') }}</template>
      <div class="mt-4 mb-40" style="color:#7D7C7B">
        {{ $t('forgot.backtopage') }}
        <router-link to="/login">
          {{ $t('forgot.signin') }}
        </router-link>
      </div>
      <div class="mb-40" style="color:#7D7C7B">
        {{ $t('forgot.description') }}
      </div>
      <el-form
        ref="refForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        @keyup.enter="hanldeForgot"
        @submit.prevent>
        <el-form-item :label="$t('login.email')" prop="email">
          <el-input v-model="formData.email" />
        </el-form-item>
        <el-form-item>
          <recaptcha ref="refRecaptcha" @response="handleRecaptchaResponse" />
        </el-form-item>
        <el-form-item>
          <el-button
            :disabled="disableForgot"
            :loading="loading"
            type="primary"
            class="btn-full-block"
            @click="hanldeForgot">
            {{ $t('forgot.send') }}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import Recaptcha from '@/components/Recaptcha'

const { t } = useI18n()
const store = useStore()
const loading = ref(false)
const refForm = ref(null)
const refRecaptcha = ref(null)
const formData = reactive({
  email: '',
  g_recaptcha_response: ''
})
const rules = reactive({
  email: [{ required: true, type: 'email', trigger: 'blur' }]
})
const disableForgot = computed(() => {
  if (
    formData.email &&
    formData.g_recaptcha_response
  ) {
    return false
  } else {
    return true
  }
})
const handleRecaptchaResponse = (response, type) => {
  if (type === 'success') {
    formData.g_recaptcha_response = response
  } else {
    formData.g_recaptcha_response = null
  }
}
const hanldeForgot = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      store.dispatch('app/fetchForgetPassword', formData).then(() => {
        refRecaptcha.value.handleReset()
        loading.value = false
        ElMessage({
          type: 'success',
          message: t('forgot.forgot_success')
        })
      }).catch((error) => {
        loading.value = false
        ElMessage({
          type: 'error',
          message: t('forgot.forgot_failed')
        })
        console.log(error)
      })
    } else {
      loading.value = false
      ElMessage({
        type: 'warning',
        message: t('warning.complete_the_data')
      })
      return false
    }
  })
}
</script>
